import { render, staticRenderFns } from "./HomeType12.vue?vue&type=template&id=06e7c208&scoped=true&"
import script from "./HomeType12.vue?vue&type=script&lang=js&"
export * from "./HomeType12.vue?vue&type=script&lang=js&"
import style0 from "./HomeType12.vue?vue&type=style&index=0&id=06e7c208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7c208",
  null
  
)

export default component.exports